module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent-head"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Emerging Civil War Series")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("offers compelling, easy-to-read overviews of some of the Civil War’s most important battles and stories.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Recipient of the Army Historical Foundation’s Lieutenant General Richard G. Trefry Award for contributions to the literature on the history of the U.S. Army")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00ii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("For a complete list of titles in the Emerging Civil War Series,"), _c('br'), _vm._v(" visit "), _c('a', {
    attrs: {
      "href": "http://www.emergingcivilwar.com",
      "target": "_blank"
    }
  }, [_vm._v("www.emergingcivilwar.com")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466cde58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Fm01.vue
// module id = 60
// module chunks = 0